export const colors = {
  green: '#61a5a0',
  red: '#c15953',
  bgDark: '#f2f1ed',
  bgLight: '#f9f8f4',
  navy: '#3d4349',
  gray: '#737276',
  lightGray: '#DADBDC',
  white: '#fff',
  black: '#000',
};

export const widths = {
  mobileSmallest: '(max-width: 350px)',
  mobileSmall: '(max-width: 400px)',
  mobile: '(max-width: 710px)',
  iphoneX: '(max-width: 400px) and (min-height: 800px)',
  tabletSmall: '(min-width: 711px) and (max-width: 767px)',
  tablet: '(min-width: 711px) and (max-width: 990px)',
  device: '(max-width: 990px)',
  desktop: '(min-width: 991px)',
  desktopSmall: '(min-width: 991px) and (max-width: 1200px)',
  desktopLarge: '(min-width: 1201px)',
  landscape: '(orientation: landscape)',
  portrait: '(orientation: portrait)',
};
